import React from 'react'

import FeedEmpty from '../FeedEmpty'
import FeedLeaderBoardItem from './FeedLeaderBoardItem'
import FeedLeaderBoardListLoader from 'app/domains/common/Loaders/FeedLeaderBoardListLoader'

const FeedLeaderBoardList = ({ leaderBoardList, pending }) => (
  <div className="leader-board-list-wrapper">
    {pending ? (
      <FeedLeaderBoardListLoader />
    ) : leaderBoardList.size ? (
      <ul className="leader-board-list">
        {leaderBoardList.map((leaderBoardItem, key) => (
          <FeedLeaderBoardItem key={key} index={key} leaderBoardItem={leaderBoardItem.toJS()} />
        ))}
      </ul>
    ) : (
      <FeedEmpty listType="leaderBoard" />
    )}
  </div>
)

export default FeedLeaderBoardList
